module.exports = __webpack_public_path__ + "img/check.dd480b0d.svg";